export default "__VITE_ASSET__DUDUBh3e__"